import ReportDetailScreen from '@screens/ReportDetail/ReportDetailScreen';

export default ReportDetailScreen;
